function setCardsHeight(){
  const cards = $('.realisations .realisations_lastNews-link > .realisations_lastNews');
  let height = 0;

  cards.css('height', 'fit-content');

  cards.each(function(){
    if($(this).innerHeight() > height){
      height = $(this).innerHeight();
    }
  });

  cards.css('height', `${height}px`);

  setTimeout(()=>{
    setCardsHeight();
  },500)
}

jQuery(document).ready(function () {
  if ($(".realisations").length > 0) {
    var allReal = $(".realisations_lastNews-link");
    var itemToDisplay = 9;
    var thematique;
    var allItem = allReal.length;

    $(document).ready(function () {
      var currentUrl = window.location.href;

      if (currentUrl.indexOf('?=') !== -1) {
        var queryString = currentUrl.split('?=')[1];

        var targetElement = $('#' + queryString);

        if (targetElement.length) {
          targetElement.trigger('click');
        }
      }
    });

    function find3n() {
      // $(".realisations_lastNews-link:visible:nth-of-type(3n)");
      var test = $(".realisations_lastNews-link");
      if (test.is(":visible")) {
        console.log("visible");
      }
    }
    find3n();

    function defineCardToDisplay() {
      if (allItem > itemToDisplay) {
        $(".realisations_showMore").show();
      }

      $(".realisations_lastNews-link:lt(" + itemToDisplay + ")").show();

      $(".realisations_showMore").click(function () {
        itemToDisplay = itemToDisplay + 3;

        if (thematique == undefined) {
          $(".realisations_lastNews-link:lt(" + itemToDisplay + ")").show();
        } else {
          $(
            ".realisations_lastNews-" +
              thematique +
              ":lt(" +
              itemToDisplay +
              ")"
          ).show();
        }
        if (allItem <= itemToDisplay) {
          $(".realisations_showMore").hide();
        }
      });
    }
    defineCardToDisplay();

    $(".realisations_filterItem").click(function () {
      $(".realisations_filterItem").removeClass(
        "realisations_filterItem-active"
      );
      $(this).toggleClass("realisations_filterItem-active");
      thematique = $(this).attr("id");
      var thematiqueItem = $(".realisations_lastNews-" + thematique).length;
      allItem = thematiqueItem;
      if (thematiqueItem <= itemToDisplay) {
        $(".realisations_showMore").hide();
      } else {
        $(".realisations_showMore").show();
      }
      allReal.hide();
      var count = 0;
      allReal.each(function (index) {
        if ($(this).data(thematique)) {
          if (count < itemToDisplay) {
            $(this).show();
            count++;
          }
        }
      });
    });
  }

  setCardsHeight();
});
